// extracted by mini-css-extract-plugin
export var alertLink = "index-module--alertLink--Cl6Zq";
export var alertMessage = "index-module--alertMessage--vP37h";
export var closeButton = "index-module--closeButton--SlWaC";
export var container = "index-module--container--z8-2C";
export var hidden = "index-module--hidden--uEla5";